import './App.css';
import Privacidade from './components/Privacidade';

function App() {
  return (
    <div className="App">
      <Privacidade />   
    </div>
  );
}

export default App;
